// hooks/useReferralTracking.ts
import { useEffect } from 'react';
import { addGclidToLocalStorage, addLabelToLocalStorage } from '../../../hotel/referral';

export const useReferralTracking = () => {
    useEffect(() => {
        addGclidToLocalStorage();
        addLabelToLocalStorage();
    }, []);
};
